/**
 * Имя пользовательских события для Ifurn
 *
 */
export const EventsIfurn = {
    checkInCart: "ifurnCheckInCart",
    addToCart: "ifurnAddToCart",
    removeFromCart: "ifurnRemoveFromCart",

}
/**
 * Имя пользовательских события для модальног окна
 *
 */
export const EventsModal ={
    modalShow: "modalShow",
    modalHide: "modalHide",
}